module.exports = __webpack_public_path__ + "static/logo-mobile-7b11dbe1cd386665164ce5e47e6ce288.jpg";